export const GENERALTABLECOLUMNSALL_REQUEST = "GENERALTABLECOLUMNSALL_REQUEST";
export const GENERALTABLECOLUMNSALL_SUCCESS = "GENERALTABLECOLUMNSALL_SUCCESS";
export const GENERALTABLECOLUMNSALL_FAIL = "GENERALTABLECOLUMNSALL_FAIL";